import { useEffect, useRef } from 'react'
import Footer from './Footer'

/** Footer below the fold; animates in when scrolled into view (minimal home). */
const FooterScrollReveal = () => {
  const wrapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = wrapRef.current
    if (!el) return
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion) {
      el.classList.add('is-revealed')
      return
    }
    let done = false
    const reveal = () => {
      if (done) return
      done = true
      el.classList.add('is-revealed')
    }
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          reveal()
          obs.disconnect()
        }
      },
      { threshold: 0, rootMargin: '0px 0px 100px 0px' },
    )
    obs.observe(el)
    return () => obs.disconnect()
  }, [])

  return (
    <div ref={wrapRef} className="app-footer-reveal">
      <Footer />
    </div>
  )
}

export default FooterScrollReveal
